"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerAll = exports.find = exports.register = exports.EVoyageMissionType = exports.EVoyageMissionCategory = exports.generator_mission_null = void 0;
var entitiesUtils_sidecar_1 = require("@entities/entitiesUtils-sidecar");
var voyageMissionDataWaves_1 = require("./voyageMissionDataWaves");
var voyageMissionDataWaves_sidecar_1 = require("./voyageMissionDataWaves-sidecar");
var voyageMission_null_sidecar_1 = require("./voyageMission_null-sidecar");
var voyageMission_test_sidecar_1 = require("./voyageMission_test-sidecar");
var voyageMission_waves_sidecar_1 = require("./voyageMission_waves-sidecar");
var label = 'mission-data';
function generator_mission_null() {
    return __generator(this, function (_a) {
        return [2 /*return*/, 0];
    });
}
exports.generator_mission_null = generator_mission_null;
var EVoyageMissionCategory;
(function (EVoyageMissionCategory) {
    EVoyageMissionCategory[EVoyageMissionCategory["Default"] = -1] = "Default";
    EVoyageMissionCategory[EVoyageMissionCategory["Null"] = 0] = "Null";
    EVoyageMissionCategory[EVoyageMissionCategory["Survey"] = 1] = "Survey";
    EVoyageMissionCategory[EVoyageMissionCategory["FightAliens"] = 2] = "FightAliens";
    EVoyageMissionCategory[EVoyageMissionCategory["FightAlienShip"] = 3] = "FightAlienShip";
    EVoyageMissionCategory[EVoyageMissionCategory["CombatZone"] = 4] = "CombatZone";
    EVoyageMissionCategory[EVoyageMissionCategory["Test"] = 5] = "Test";
    EVoyageMissionCategory[EVoyageMissionCategory["Starbase"] = 6] = "Starbase";
    EVoyageMissionCategory[EVoyageMissionCategory["Hyperspace"] = 7] = "Hyperspace";
})(EVoyageMissionCategory = exports.EVoyageMissionCategory || (exports.EVoyageMissionCategory = {}));
var EVoyageMissionType;
(function (EVoyageMissionType) {
    EVoyageMissionType[EVoyageMissionType["Default"] = -1] = "Default";
    EVoyageMissionType[EVoyageMissionType["Null"] = 0] = "Null";
    EVoyageMissionType[EVoyageMissionType["Hyperspace"] = 1] = "Hyperspace";
    EVoyageMissionType[EVoyageMissionType["Starbase"] = 2] = "Starbase";
    EVoyageMissionType[EVoyageMissionType["SurveySun1"] = 3] = "SurveySun1";
    EVoyageMissionType[EVoyageMissionType["SurveySun2"] = 4] = "SurveySun2";
    EVoyageMissionType[EVoyageMissionType["SurveySun3"] = 5] = "SurveySun3";
    EVoyageMissionType[EVoyageMissionType["SurveyAnomaly"] = 6] = "SurveyAnomaly";
    EVoyageMissionType[EVoyageMissionType["FightAliens1"] = 7] = "FightAliens1";
    EVoyageMissionType[EVoyageMissionType["FightAliens2"] = 8] = "FightAliens2";
    EVoyageMissionType[EVoyageMissionType["FightAliens3"] = 9] = "FightAliens3";
    EVoyageMissionType[EVoyageMissionType["FightAlienShip1"] = 10] = "FightAlienShip1";
    EVoyageMissionType[EVoyageMissionType["FightAlienShip2"] = 11] = "FightAlienShip2";
    EVoyageMissionType[EVoyageMissionType["FightAlienShip3"] = 12] = "FightAlienShip3";
    EVoyageMissionType[EVoyageMissionType["CombatZone1"] = 13] = "CombatZone1";
    EVoyageMissionType[EVoyageMissionType["Test1"] = 14] = "Test1";
})(EVoyageMissionType = exports.EVoyageMissionType || (exports.EVoyageMissionType = {}));
var _default = {
    type: EVoyageMissionType.Default,
    category: EVoyageMissionCategory.Default,
    name: 'default',
    numAliens: 0,
    scanTime: 0,
    genMission: voyageMission_null_sidecar_1.voyageMission_null.generator_mission_null,
    genWaves: function () { return []; },
};
var dataList = [];
var dataMap = {};
function register(data) {
    return entitiesUtils_sidecar_1.entitiesUtils.genericRegisterDataNum(label, data, _default, dataList, dataMap);
}
exports.register = register;
function find(type) {
    return entitiesUtils_sidecar_1.entitiesUtils.genericGetDataNum(label, dataMap, type);
}
exports.find = find;
function registerAll() {
    register({
        type: EVoyageMissionType.Null,
        category: EVoyageMissionCategory.Null,
        name: 'Null Mission',
    });
    register({
        type: EVoyageMissionType.Hyperspace,
        category: EVoyageMissionCategory.Hyperspace,
        name: 'Hyperspace',
    });
    register({
        type: EVoyageMissionType.Test1,
        category: EVoyageMissionCategory.Test,
        name: 'Dev Test 1',
        genMission: voyageMission_test_sidecar_1.voyageMission_test.generator_mission_test,
        // scanTime: 90,
    });
    register({
        type: EVoyageMissionType.Starbase,
        category: EVoyageMissionCategory.Starbase,
        name: 'Starbase',
    });
    // TODO: add different ship types
    register({
        type: EVoyageMissionType.FightAlienShip1,
        category: EVoyageMissionCategory.FightAlienShip,
        name: 'Destroy Alien Squid Ship',
        genMission: voyageMission_waves_sidecar_1.voyageMission_waves.generator_mission_waves,
        genWaves: function () {
            var waves = [];
            waves.push(voyageMissionDataWaves_sidecar_1.voyageMissionDataWaves.create(voyageMissionDataWaves_1.EVoyageWaveType.AlienShip, {
                amount: 1,
            }));
            return waves;
        },
    });
    register({
        type: EVoyageMissionType.FightAlienShip2,
        category: EVoyageMissionCategory.FightAlienShip,
        name: 'Destroy Alien Hammerhead Ship',
        genMission: voyageMission_waves_sidecar_1.voyageMission_waves.generator_mission_waves,
        genWaves: function () {
            var waves = [];
            waves.push(voyageMissionDataWaves_sidecar_1.voyageMissionDataWaves.create(voyageMissionDataWaves_1.EVoyageWaveType.AlienShip, {
                amount: 1,
            }));
            return waves;
        },
    });
    register({
        type: EVoyageMissionType.FightAlienShip3,
        category: EVoyageMissionCategory.FightAlienShip,
        name: 'Destroy Alien Juggernaut Ship',
        genMission: voyageMission_waves_sidecar_1.voyageMission_waves.generator_mission_waves,
        genWaves: function () {
            var waves = [];
            waves.push(voyageMissionDataWaves_sidecar_1.voyageMissionDataWaves.create(voyageMissionDataWaves_1.EVoyageWaveType.AlienShip, {
                amount: 1,
            }));
            return waves;
        },
    });
    register({
        type: EVoyageMissionType.FightAliens1,
        category: EVoyageMissionCategory.FightAliens,
        name: 'Eliminate Small Alien Squad',
        genMission: voyageMission_waves_sidecar_1.voyageMission_waves.generator_mission_waves,
        genWaves: function () {
            var waves = [];
            waves.push(voyageMissionDataWaves_sidecar_1.voyageMissionDataWaves.create(voyageMissionDataWaves_1.EVoyageWaveType.BoardedByAliens, {
                amount: 2,
            }), voyageMissionDataWaves_sidecar_1.voyageMissionDataWaves.create(voyageMissionDataWaves_1.EVoyageWaveType.BoardedByAliens, {
                amount: 3,
            }));
            return waves;
        },
    });
    register({
        type: EVoyageMissionType.FightAliens2,
        category: EVoyageMissionCategory.FightAliens,
        name: 'Eliminate Medium Alien Squad',
        genMission: voyageMission_waves_sidecar_1.voyageMission_waves.generator_mission_waves,
        genWaves: function () {
            var waves = [];
            waves.push(voyageMissionDataWaves_sidecar_1.voyageMissionDataWaves.create(voyageMissionDataWaves_1.EVoyageWaveType.BoardedByAliens, {
                amount: 3,
            }), voyageMissionDataWaves_sidecar_1.voyageMissionDataWaves.create(voyageMissionDataWaves_1.EVoyageWaveType.BoardedByAliens, {
                amount: 4,
            }), voyageMissionDataWaves_sidecar_1.voyageMissionDataWaves.create(voyageMissionDataWaves_1.EVoyageWaveType.BoardedByAliens, {
                amount: 6,
            }));
            return waves;
        },
    });
    register({
        type: EVoyageMissionType.FightAliens3,
        category: EVoyageMissionCategory.FightAliens,
        name: 'Eliminate Large Alien Squad',
        genMission: voyageMission_waves_sidecar_1.voyageMission_waves.generator_mission_waves,
        genWaves: function () {
            var waves = [];
            waves.push(voyageMissionDataWaves_sidecar_1.voyageMissionDataWaves.create(voyageMissionDataWaves_1.EVoyageWaveType.BoardedByAliens, {
                amount: 4,
            }), voyageMissionDataWaves_sidecar_1.voyageMissionDataWaves.create(voyageMissionDataWaves_1.EVoyageWaveType.BoardedByAliens, {
                amount: 6,
            }), voyageMissionDataWaves_sidecar_1.voyageMissionDataWaves.create(voyageMissionDataWaves_1.EVoyageWaveType.BoardedByAliens, {
                amount: 10,
            }));
            return waves;
        },
    });
    register({
        type: EVoyageMissionType.SurveyAnomaly,
        category: EVoyageMissionCategory.Survey,
        name: 'Survey Anomaly',
        scanTime: 30,
        // genMission: voyageMission_waves.generator_mission_waves,
    });
    register({
        type: EVoyageMissionType.SurveySun1,
        category: EVoyageMissionCategory.Survey,
        name: 'Survey Small Sun',
        scanTime: 30,
        // genMission: voyageMission_waves.generator_mission_waves,
    });
    register({
        type: EVoyageMissionType.SurveySun2,
        category: EVoyageMissionCategory.Survey,
        name: 'Survey Medium Sun',
        scanTime: 60,
        // genMission: voyageMission_waves.generator_mission_waves,
    });
    register({
        type: EVoyageMissionType.SurveySun3,
        category: EVoyageMissionCategory.Survey,
        name: 'Survey Supernova',
        scanTime: 90,
    });
    register({
        type: EVoyageMissionType.CombatZone1,
        category: EVoyageMissionCategory.CombatZone,
        name: 'Combat Zone 1',
        // scanTime: 90,
    });
}
exports.registerAll = registerAll;
